import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "provider flex h-auto gap-2 p-0 px-2 border-round-md flex-wrap justify-content-start align-items-center" }

import { toRefs } from 'vue';

import DisciplineIcon from '@/components/DisciplineIcon';

interface Props {
  disciplineCode: string | null;
  serviceProviderName: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'Provider',
  props: {
    disciplineCode: {},
    serviceProviderName: {}
  },
  setup(__props: any) {

const props = __props;

const { disciplineCode, serviceProviderName } = toRefs(props);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(disciplineCode))
      ? (_openBlock(), _createBlock(_unref(DisciplineIcon), {
          key: 0,
          classes: "0",
          "divider-width": "0",
          code: _unref(disciplineCode),
          "see-code": false
        }, null, 8, ["code"]))
      : _createCommentVNode("", true),
    _createTextVNode(" " + _toDisplayString(_unref(serviceProviderName)), 1)
  ]))
}
}

})